import React, {useContext} from 'react';
import {Platform, View} from 'react-native';

import Text from '../../elements/Text';
import DashedDivider from '../../elements/DashedDivider';
import ProductCard from '../ProductCard';

import makeStyles from './styles';
import {useTheme, useThemedStyles} from '../../../theme';
import {shopContext} from '../../../contexts/ShopContext';
import {tID} from '../../../utils/TestIdHelper';

const CheckoutItemCard = ({item, index}) => {
  const ShopC = useContext(shopContext);
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);

  const onDeleteItem = () => {
    let items = [...ShopC.cartProducts];
    const _ = items.splice(index, 1);
    ShopC.setCartProducts(items);
  };

  const renderShippingDetailsRow = (title, value) => (
    <View style={styles.shippingDetailRow}>
      <Text
        testID={tID('CheckoutItemCard-Text-Title')}
        variation="Text1Regular"
        color={colors.textDisabled}>
        {title}
      </Text>
      <Text
        testID={tID('CheckoutItemCard-Text-Value')}
        variation="Text1Regular"
        color={colors.textPrimary}>
        {value}
      </Text>
    </View>
  );

  return (
    <View
      testID={tID('CheckoutItemCard-View-Container')}
      style={styles.container}>
      <ProductCard
        showMenu={Platform.OS !== 'web'}
        imageStyle={styles.productImage}
        style={styles.productInfoView}
        product={item}
        onDelete={onDeleteItem}
      />
      <View style={styles.marginVertical16}>
        <DashedDivider color={colors.border} dashWidth={5} space={5} />
      </View>
      {renderShippingDetailsRow(
        Platform.OS === 'web' ? 'Quantity:' : 'Qty',
        item.productQty,
      )}
    </View>
  );
};

export default CheckoutItemCard;
